export enum InsuranceType {
  CAR = 'C',
  AUTO_LIFE = 'A'
}
